<template lang="pug">
div.animated.fadeIn
  b-row#home
    b-col(md='3', v-if='userAccessLevel != "agent"')
      b-link(to='/dashboard')
        b-card.text-center
          h6.card-title.my-3
            i.icon-grid
            br
            | Dashboard
    b-col(md='3')
      b-link(to='/interactions/live')
        b-card.text-center
          h6.card-title.my-3
            i.icon-bubbles
            br
            | Interactions
    b-col(md='3')
      b-link(to='/videoCall')
        b-card.text-center
          h6.card-title.my-3
            i.icon-bubbles
            br
            | Video Call
    b-col(md='3')
      b-link(to='/reports')
        b-card.text-center
          h6.card-title.my-3
            i.icon-people
            br
            | Customers
    b-col(md='3')
      b-link(to='/broadcast')
        b-card.text-center
          h6.card-title.my-3
            i.icon-speech
            br
            | Broadcast
    b-col(md='3')
      b-link(to='/graph')
        b-card.text-center
          h6.card-title.my-3
            i.icon-graph
            br
            | Graph
    b-col(md='3')
      b-link(to='/chatflow')
        b-card.text-center
          h6.card-title.my-3
            i.icon-shuffle
            br
            | Chat Flow (Beta)
    b-col(md='3')
      b-link(to='/manual')
        b-card.text-center
          h6.card-title.my-3
            i.icon-notebook
            br
            | User Manual
    b-col(md='3')
      b-link(to='/profile')
        b-card.text-center
          h6.card-title.my-3
            i.icon-user
            br
            | Profile
    b-col(md='3')
      b-link(to='/crm/chatbot')
        b-card.text-center
          h6.card-title.my-3
            i.fa.fa-id-card-o
            br
            | Task Reporting CRM
    b-col(md='3')
      b-link(to='/crm/chatbot')
        b-card.text-center
          h6.card-title.my-3
            i.fa.fa-car
            br
            | Motor Accident CRM
    b-col(md='3')
      b-link(to='/studio')
        b-card.text-center
          h6.card-title.my-3
            i.fa.fa-magic
            br
            | NL Studio
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
    }
  },
  mounted: function() {
  },
  methods: {
    // User Chat Link
    chatLink (value) {
      return '/interactions/' + value.toLowerCase().replace(' ', '-')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue?7d7c2cfb